import { useAppSelector } from 'app/store/hooks';
import { selectUser } from './user/store/userSlice';

/**
 * Custom hook that returns the appropriate redirect URL based on user role
 */
export function useRoleBasedRedirect() {
    const user = useAppSelector(selectUser);
    
    const getRoleBasedRedirectUrl = (): string => {
        if (!user || !user.role) {
            return '/home';
        }
        
        const userRole = user.role;
        
        // Helper function to check if user has role
        const hasRole = (role: string) => {
            return Array.isArray(userRole) ? userRole.includes(role) : userRole === role;
        };
        
        // Determine redirect URL based on role priority
        if (hasRole('Main Cleaner') || hasRole('Cleaner')) {
            return '/clean';
        }
        
        if (hasRole('Tech Support')) {
            return '/maintenance';
        }
        
        if (hasRole('Reception')) {
            return '/roomie-ai';
        }
        
        if (hasRole('Godfather')) {
            return '/admin/notifications';
        }
        
        // Admin and others go to home
        return '/home';
    };
    
    return { getRoleBasedRedirectUrl };
}